import React from "react";
import { StyleSheet, View, Text } from "react-native";
import { colors, fonts } from "../../theme";
import { translateNode, useLanguage } from "../../i18n";

const styles = StyleSheet.create({
  title: {
    fontFamily: fonts.regular,
    textTransform: "uppercase",
    fontSize: 16,
    lineHeight: 18,
    color: colors.white,
    letterSpacing: 1,
    textAlign: "center",
  },
});

type Props = {};

const ScreenHeaderTitle: React.FC<Props> = ({ children }) => {
  const { t } = useLanguage();
  return <Text style={styles.title}>{translateNode(children, t)}</Text>;
};

export default ScreenHeaderTitle;
